<template>
  <div>
    <template v-if="table_cancellations.items.length > 0">
      <app-cells><h2 class="title">Cancellations</h2></app-cells>
      <v-client-table
        :data="table_cancellations.items"
        :columns="table_cancellations.columns"
        :options="table_cancellations.options"
        class="table-default"
      >
        <template #count="{ row, index }">{{ index }}</template>
        <template #created_by="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by?.crop?.crop_url)" alt="Avatar"
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10, html: true }"
              >
            </div>
            {{ dateTimeFormat(row.created_at) }}
          </div>
        </template>
        <template #updated_by="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.updated_by?.crop?.crop_url)" alt="Avatar"
                v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10, html: true }"
              >
            </div>
            {{ dateTimeFormat(row.updated_at) }}
          </div>
        </template>
        <template #sales_status="{ row }">
          <div class="status-tag" :style="{ 'backgroundColor': row.sales_status.color }">
            {{ row.sales_status.name }}
          </div>
        </template>
        <template #reservation_status="{ row }">
          <div class="status-tag" :style="{ 'backgroundColor': row.reservation_status.color }">
            {{ row.reservation_status.name }}
          </div>
        </template>
        <template #amount="{ row }">{{ row.amount ? `${row.amount} $` : '-' }}</template>
      </v-client-table>
    </template>
    <template v-if="table_amendments.items.length > 0">
      <app-cells><h2 class="title">Amendments</h2></app-cells>
      <v-client-table
        :data="table_amendments.items"
        :columns="table_amendments.columns"
        :options="table_amendments.options"
        class="table-default"
      >
        <template #count="{ row, index }">{{ index }}</template>
        <template #created_by="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by?.crop?.crop_url)" alt="Avatar"
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10, html: true }"
              >
            </div>
            {{ dateTimeFormat(row.created_at) }}
          </div>
        </template>
        <template #updated_by="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.updated_by?.crop?.crop_url)" alt="Avatar"
                v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10, html: true }"
              >
            </div>
            {{ dateTimeFormat(row.updated_at) }}
          </div>
        </template>
        <template #sales_status="{ row }">
          <div class="status-tag" :style="{ 'backgroundColor': row.sales_status.color }">
            {{ row.sales_status.name }}
          </div>
        </template>
        <template #reservation_status="{ row }">
          <div class="status-tag" :style="{ 'backgroundColor': row.reservation_status.color }">
            {{ row.reservation_status.name }}
          </div>
        </template>
        <template #amount="{ row }">{{ row.amount ? `${row.amount} $` : '-' }}</template>
      </v-client-table>
    </template>
    <app-no-results
      v-if="table_cancellations.items.length < 1 && table_amendments.items.length < 1"
      text="There’s no reservations yet"
    />
  </div>
</template>

<script>
import {
  getReservationsFlightAmendmentRequest,
  getReservationsFlightCancellationRequest,
} from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'HotelsReservationsHistory',
  data() {
    return {
      table_cancellations: {
        items: [],
        columns: ['count', 'created_by', 'updated_by', 'sales_status', 'reservation_status', 'amount'],
        options: {
          headings: {
            count: '#',
            created_by: 'Created by',
            updated_by: 'Updated by',
            sales_status: 'Sales status',
            reservation_status: 'Reservation status',
            amount: 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_amendments: {
        items: [],
        columns: ['count', 'created_by', 'updated_by', 'sales_status', 'reservation_status', 'amount'],
        options: {
          headings: {
            count: '#',
            created_by: 'Created by',
            updated_by: 'Updated by',
            sales_status: 'Sales status',
            reservation_status: 'Reservation status',
            amount: 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
    }
  },
  created() {
    Promise.all([
      getReservationsFlightCancellationRequest({ reservation__id: this.$route.params.id }),
      getReservationsFlightAmendmentRequest({ reservation__id: this.$route.params.id }),
    ])
      .then(res => {
        this.table_cancellations.items = res[0].data
        this.table_amendments.items = res[1].data
      })
  },
  methods: {
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
